import { InvoicesQuery } from '@boels-state/state/query.state';

export class SetInvoicesQuery {
  public static readonly type = '[Query] Set Invoices Query';

  constructor(public latestInvoicesQuery: InvoicesQuery) {}
}
